import apiV2 from '../api/v2';

export interface PracticeUser {
    email: string;
    fullname: string;
    isAdmin: boolean;
    practices: string[];
    createdAt: string;
    lastActivityAt: string | null;
}

export async function fetchPracticeUsers(practiceId: string): Promise<PracticeUser[]> {
    const response = await apiV2.get<PracticeUser[]>(`/practices/${practiceId}/users`);
    return response.data;
}

export async function addPracticeUser(
    practiceId: string,
    input: { email: string; fullname: string }
): Promise<PracticeUser> {
    const response = await apiV2.post<PracticeUser>(`/practices/${practiceId}/users`, input);
    return response.data;
}

export async function removePracticeUser(practiceId: string, email: string): Promise<void> {
    await apiV2.delete(`/practices/${practiceId}/users`, { data: { email } });
}
